import {
  IUpdateProcessingRuleTierDto,
  IUpdateProcessingRuleTierDtoPayoutRuleTypeEnum,
  IUpdateProcessingRuleTiersDto,
} from '@/dtos';

export type UpdateProcessingRuleTiersPayload = IUpdateProcessingRuleTiersDto;
export type UpdateProcessingRuleTierPayload = IUpdateProcessingRuleTierDto;
export const ProcessingRuleTierPayoutRuleType = IUpdateProcessingRuleTierDtoPayoutRuleTypeEnum;
